<mat-form-field appearance="outline" class="app-date-field-picker w-100">
  <input matInput [matDatepicker]="picker" [formControl]="asFormControl"
         [max]="max" [min]="min" readonly
         (dateChange)="onDateChange()">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
